import { AuthClient } from "commonModule/services/client"
import { defaultAxiosInstance } from "services/client"

export const apiAuthClient = new AuthClient(defaultAxiosInstance)
